var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Google Meet",
    role: "img",
    viewBox: "0 0 512 512",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 106v90h-90",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 106v90h120v62l90-73v-49q0-30-30-30",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 406v-90h122v-60l90 71v49q0 30-30 30",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 256l90-73v146",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 183l42-34c9-7 18-7 18 7v200c0 14-9 14-18 7l-42-34",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 314v62q0 30 30 30h60v-92",
    fill: "#0B7077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 196h90v120h-90",
    fill: "#0B7077"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6cb0abfc8f102ebd61696aa7b06c53d7.svg";
export { ForwardRef as ReactComponent };